import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "image-rendering": "optimizeQuality",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision",
  viewBox: "0 0 1024 1024",
  width: "48px",
  height: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-a5bf64b1-6ab9-46ff-81d1-35a0b830dcc6-__图层_x0020_1\" transform=\"matrix(403.149597, 0, 0, 403.149597, 0.000019, 0.000019)\"><circle cx=\"1.27\" cy=\"1.27\" fill=\"#48b02c\" r=\"1.27\"></circle><g fill=\"#fff\"><path d=\"m.96229 1.62644.8951-.89509c.02637-.02638.06967-.02611.09578 0l.08642.08642c.02611.02611.02611.06968 0 .09578l-.89509.8951c-.02611.02611-.06941.02638-.09579 0l-.08642-.08642c-.02638-.02638-.02638-.06941 0-.09579z\"></path><path d=\"m.6827 1.08089.54525.54525c.02637.02638.02606.06973 0 .09579l-.08642.08642c-.02606.02605-.06973.02605-.09579 0l-.54525-.54525c-.02606-.02606-.02637-.06941 0-.09579l.08642-.08642c.02638-.02637.06941-.02637.09579 0z\"></path></g></g>", 1)
  ]))]))
}
export default { render: render }